<template>
  <header class="site-header">
    <div class="site-container site-header__inner">
      <router-link to="/" class="brand-mark" aria-label="JL Consultorías inicio">
        <img src="/img/logo-jl.png" alt="JL Consultorías" class="brand-mark__image" />
      </router-link>

      <button class="menu-toggle" type="button" @click="toggleMenu" :aria-expanded="menuOpen.toString()">
        Menú
      </button>

      <nav class="site-nav" :class="{ 'is-open': menuOpen }" aria-label="Navegación principal">
        <router-link v-for="item in navItems" :key="item.label" :to="item.to" @click.native="closeMenu">
          {{ item.label }}
        </router-link>
        <a class="site-nav__cta" href="https://calendly.com/germanlamela98/30min" target="_blank" rel="noopener">
          Solicitar consulta
        </a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'StarterNavbar',
  data() {
    return {
      menuOpen: false,
      navItems: [
        { label: 'Inicio', to: '/' },
        { label: 'Servicios', to: { path: '/', hash: '#servicios' } },
        { label: 'Sobre Mí', to: { path: '/', hash: '#credenciales' } },
        { label: 'Contacto', to: { path: '/', hash: '#contacto' } }
      ]
    };
  },
  watch: {
    $route() {
      this.closeMenu();
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: rgba(10, 14, 20, 0.9);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(59, 73, 76, 0.45);
}

.site-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 5rem;
}

.brand-mark {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.brand-mark__image {
  display: block;
  width: auto;
  height: 2rem;
}

.menu-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.8rem;
  padding: 0 1rem;
  border: 1px solid rgba(59, 73, 76, 0.7);
  background: transparent;
  color: var(--accent-color);
  font-family: var(--font-label);
  font-size: 0.75rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.site-nav {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: var(--site-padding);
  right: var(--site-padding);
  display: none;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--surface-color);
  border: 1px solid rgba(59, 73, 76, 0.7);
}

.site-nav.is-open {
  display: grid;
}

.site-nav a {
  color: var(--text-color);
  font-family: var(--font-display);
  font-size: 0.76rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.site-nav a.router-link-exact-active {
  color: var(--accent-color);
}

.site-nav__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.9rem;
  padding: 0 1.5rem;
  background: var(--accent-color);
  color: #00363d !important;
  font-family: var(--font-label) !important;
  letter-spacing: 0.1em !important;
  text-transform: uppercase;
}

@media (min-width: 992px) {
  .menu-toggle {
    display: none;
  }

  .site-nav,
  .site-nav.is-open {
    position: static;
    display: flex;
    align-items: center;
    padding: 0;
    border: 0;
    background: transparent;
  }
}
</style>
